import { Dashboard, CommentsReport } from '@/components';

export const CommentsReportPage = (): JSX.Element => (
  <Dashboard>
    <CommentsReport />
  </Dashboard>
);
